<template>
	<div>
		<div class="container">
			<div class="infoContain">
				<div>
					<div class="article mt-4">
						<div class="textAreaBox inputBox">
							<label>회사 소개</label>
							<textarea
								v-model="signupInfo.aboutMe"
								placeholder="노년의 삶을 더 행복하게 만드는 기업"
							></textarea>
						</div>

						<div class="article">
							<div class="textAreaBox inputBox">
								<label>인재상</label>
								<textarea
									v-model="signupInfo.idealTalent"
									placeholder="창의적이고 배려심 높은 사람"
								></textarea>
							</div>

							<div class="line"></div>
							<h4 class="fs24 mt-4" style="margin-bottom: 1rem;">
								제품 및 서비스
							</h4>
							<div class="inputBox mt-3">
								<label>제품(서비스)명</label>
								<input
									v-model="signupInfo.productServiceName"
									placeholder="힐링 노화예방 크림"
									type="text"
									class="help-input"
								/>
							</div>
							<div class="textAreaBox inputBox">
								<label>제품(서비스) 설명</label>
								<textarea
									v-model="signupInfo.productServiceDesc"
									placeholder="고객을 위하는 고령친화서비스 전문 화장품 브랜드"
								></textarea>
							</div>
						</div>
					</div>

					<!-- 1 -->
					<div class="article" style="margin-bottom: 4rem !important;">
						<div class="article-title">
							<h4>나의 비즈니스</h4>
						</div>
						<template v-if="userRelevant && userRelevant.length > 0">
							<div v-for="(item, index) in userRelevant" :key="'userRelevant_' + index">
								<div class="article-explain">
									<h5>
										{{ item.text }}
									</h5>
								</div>

								<div class="flex mobileFlex mt-4" style="gap: 2rem;">
									<div
										v-for="(subItem, index2) in item.sub"
										:key="index2"
										class="checked-sectors-name-btn"
									>
										<h5>{{ subItem.text }}</h5>
									</div>
								</div>
							</div>
						</template>
					</div>

					<!-- button show more  -->
					<div class="flex flexAlignC">
						<button type="button" class="btn-outlined" @click="handleShowMoreMyBusiness">
							정보 수정
							<i class="ic ic--chevron-up"></i>
						</button>
					</div>

					<div v-if="isShowMyBusiness" class="article mt-4">
						<div class="article-explain">
							<h5>
								진행 중인 대표 사업을 선택 후, 해당되는 항목을 선택해 주세요.
							</h5>
						</div>
						<div class="flex mobileFlex">
							<div class="select-content">
								<div v-for="(relevant, index) in relevant_list" :key="index">
									<div class="checkBoxItem">
										<input
											v-model="relevant.isChecked"
											type="checkbox"
											:id="'relevantCheckbox' + relevant.value + '_' + index"
											:value="relevant.value"
										/>
										<label :for="'relevantCheckbox' + relevant.value + '_' + index">
											{{ relevant.name }}
										</label>
									</div>
									<template v-if="relevant.isChecked">
										<div class=" mt-3">
											<SelectMultipleOption
												v-model="relevant.categoryIds"
												:options="relevant.sectors"
												placeholder="업종을 선택해주세요."
											></SelectMultipleOption>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>

					<!-- 2 -->
					<div class="article" style="margin-bottom: 4rem !important;">
						<div class="article-title">
							<h4>매치메이킹 희망분야</h4>
						</div>

						<template v-if="userMatchmaking && userMatchmaking.length > 0">
							<div v-for="(item, index) in userMatchmaking" :key="'userMatchmaking_' + index">
								<div class="article-explain">
									<h5>
										{{ item.text }}
									</h5>
								</div>

								<div class="flex mobileFlex mt-4" style="gap: 2rem;">
									<div
										v-for="(subItem, index2) in item.sub"
										:key="index2"
										class="checked-sectors-name-btn"
									>
										<h5>{{ subItem.text }}</h5>
									</div>
								</div>
							</div>
						</template>
					</div>

					<!-- button show more  -->
					<div class="flex flexAlignC">
						<button type="button" class="btn-outlined" @click="handleShowFieldOfMatchmaking">
							정보 수정
							<i class="ic ic--chevron-up"></i>
						</button>
					</div>

					<!-- content 2 -->
					<div v-if="isShowFieldOfMatchmaking" class="article mt-4">
						<div class="article-explain">
							<h5>
								진행 중인 대표 사업을 선택 후, 해당되는 항목을 선택해 주세요.
							</h5>
						</div>
						<div class="flex mobileFlex">
							<div class="select-content">
								<div v-for="(matchmaking, index) in matchmaking_list" :key="index">
									<div class="checkBoxItem">
										<input
											v-model="matchmaking.isChecked"
											type="checkbox"
											:id="'relevantCheckbox' + matchmaking.value + '_' + index"
										/>
										<label :for="'relevantCheckbox' + matchmaking.value + '_' + index">
											{{ matchmaking.name }}
										</label>
									</div>
									<template v-if="matchmaking.isChecked">
										<div class=" mt-3">
											<SelectMultipleOption
												v-model="matchmaking.categoryIds"
												:options="matchmaking.sectors"
												placeholder="업종을 선택해주세요."
											></SelectMultipleOption>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>

					<!-- 3 -->
					<div style="margin-bottom: 4rem !important;">
						<div class="article" style="margin-bottom: 4rem !important;">
							<div class="article-title">
								<h4>매치메이킹 희망활동</h4>
							</div>

							<template v-if="userActivity && userActivity.length > 0">
								<div v-for="(item, index) in userActivity" :key="'useruserActivity_' + index">
									<div class="article-explain">
										<h5>
											{{ item.text }}
										</h5>
									</div>

									<div class="flex mobileFlex mt-4">
										<div class="checked-sectors-name-btn">
											<h5>
												{{ item.content }}
											</h5>
										</div>
									</div>
								</div>
							</template>
						</div>

						<div class="flex flexAlignC">
							<button
								type="button"
								class="btn-outlined"
								@click="handleShowMatchmakingHopeActivities"
							>
								정보 수정
								<i class="ic ic--chevron-up"></i>
							</button>
						</div>
					</div>

					<div
						v-if="isShowMatchmakingHopeActivities"
						class="article"
						style="border: 0px !important;"
					>
						<div class="article-title">
							<h4>매치메이킹 희망활동</h4>
						</div>
						<div class="article-explain">
							<h5>
								매치메이킹을 통해 도움받고자 하는 항목을 선택 후, 구체적인 내용을
								적어주십시오.(복수선택 가능)
							</h5>
						</div>
						<div class="flex mobileFlex">
							<div class="select-content">
								<div v-for="(activity, index) in hope_activity" :key="index">
									<div class="checkBoxItem">
										<input
											v-model="activity.isChecked"
											type="checkbox"
											:id="'activityCheckbox' + activity.value + '_' + index"
										/>
										<label :for="'activityCheckbox' + activity.value + '_' + index">
											{{ activity.name }}
										</label>
									</div>
									<div v-if="activity.isChecked" class="inputBox mt-3">
										<input
											v-model="activity.content"
											placeholder="도움 받고자 하는 내용을 구체적으로 입력하세요."
											type="text"
											class="input-grey"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import * as eventUtil from '@/utils/eventUtil'
import { hopeActivity, relevantList, matchmakingList } from '@/data/constances'
import SelectMultipleOption from '@/components/formControl/SelectMultipleOption.vue'

export default {
	components: { SelectMultipleOption },
	props: {
		form: {
			type: Object,
			required: true,
			default() {
				return {}
			},
		},
	},
	data() {
		let propsForm = this.form
		return {
			isShowMyBusiness: false,
			isShowFieldOfMatchmaking: false,
			isShowMatchmakingHopeActivities: false,
			signupInfo: {
				...this.form,
			},
			relevant_list: relevantList.map((item) => {
				let isChecked = propsForm.industries1?.some((ind) => ind.categoryIndustryId == item.value)
				let categoryIds =
					propsForm.industries1?.find((ind) => ind.categoryIndustryId == item.value)?.categoryIds ||
					[]
				return {
					...item,
					isChecked,
					categoryIds,
					selected: item.sectors.filter((ind) => categoryIds.includes(ind.value)),
					categoryIndustryId: item.value,
				}
			}),
			matchmaking_list: matchmakingList.map((item) => {
				let categoryIds =
					propsForm.industries2?.find((ind) => ind.categoryIndustryId == item.value)?.categoryIds ||
					[]
				let isChecked = propsForm.industries2?.some((ind) => ind.categoryIndustryId == item.value)
				return {
					...item,
					isChecked,
					categoryIds,
					selected: item.sectors.filter((ind) => categoryIds.includes(ind.value)),
					categoryIndustryId: item.value,
				}
			}),
			hope_activity: hopeActivity.map((item = {}) => {
				let activity = propsForm.activities?.find((ind) => ind.activityId === item.value)
				return {
					...item,
					activityId: activity?.activityId || item.value,
					content: activity?.content || '',
					isChecked: propsForm.activities?.some((ind) => ind.activityId === item.value),
				}
			}),
			options: {
				format: 'DD/MM/YYYY',
				useCurrent: false,
			},
			eventUtil: eventUtil,
		}
	},
	mounted() {
		this.signupInfo = this.form
	},
	watch: {
		formData: {
			handler(val) {
				this.$emit('update', val)
			},
			deep: true,
		},
	},
	computed: {
		...mapState('auth', ['user']),
		formData() {
			return {
				aboutMe: this.signupInfo?.aboutMe,
				idealTalent: this.signupInfo?.idealTalent,
				productServiceName: this.signupInfo?.productServiceName,
				productServiceDesc: this.signupInfo?.productServiceDesc,
				activities: this.selectedActivity,
				industries1: this.selectedRelevant,
				industries2: this.selectedMatchmaking,
			}
		},
		selectedActivity() {
			return this.hope_activity
				.filter((item) => item.isChecked)
				.map((item) => ({
					activityId: item.value,
					content: item.content,
				}))
		},
		selectedRelevant() {
			return this.relevant_list
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.categoryIndustryId,
				}))
		},
		selectedMatchmaking() {
			return this.matchmaking_list
				.filter((item) => item.isChecked)
				.map((item) => ({
					categoryIds: item.categoryIds,
					categoryIndustryId: item.categoryIndustryId,
				}))
		},
		userActivity() {
			return (
				this.user?.activities
					?.map((activity) => {
						let item = hopeActivity.find((a) => a.value == activity.activityId)
						if (!item) return null
						return {
							...activity,
							text: item.name,
						}
					})
					?.filter((item) => item !== null) || []
			)
		},
		userRelevant() {
			return (
				this.user?.industries1
					?.map((item) => {
						let obj = relevantList.find((temp) => temp.value == item.categoryIndustryId)
						if (!obj) return null
						let sub = item.categoryIds
							.map((subItem) => {
								let tmp = obj.sectors.find((a) => a.value == subItem)
								return tmp
							})
							?.filter((e) => e != null)
						return {
							...item,
							sub,
							text: obj.name,
						}
					})
					?.filter((item) => item !== null) || []
			)
		},
		userMatchmaking() {
			return (
				this.user?.industries2
					?.map((item) => {
						let obj = matchmakingList.find((temp) => temp.value == item.categoryIndustryId)
						if (!obj) return null
						let sub = item.categoryIds
							.map((subItem) => {
								let tmp = obj.sectors.find((a) => a.value == subItem)
								return tmp
							})
							?.filter((e) => e != null)
						return {
							...item,
							sub,
							text: obj.name,
						}
					})
					?.filter((item) => item !== null) || []
			)
		},
	},
	methods: {
		...mapMutations('join', ['setCurrentTab', 'setCompletedInfo']),
		...mapActions('auth', []),
		...mapActions('sms', []),
		handleShowMoreMyBusiness() {
			this.isShowMyBusiness = !this.isShowMyBusiness
		},
		handleShowFieldOfMatchmaking() {
			this.isShowFieldOfMatchmaking = !this.isShowFieldOfMatchmaking
		},
		handleShowMatchmakingHopeActivities() {
			this.isShowMatchmakingHopeActivities = !this.isShowMatchmakingHopeActivities
		},
	},
}
</script>

<style scoped lang="scss">
.rowTime ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}

.checkBoxForm ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}

.bspRadio ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
}

.bspSelectBox ::v-deep {
	@import '~bootstrap/dist/css/bootstrap.min';
	@import '~bootstrap-vue/dist/bootstrap-vue.min';
}
</style>

<style scoped lang="css">
.article {
	position: relative;
	margin-bottom: 56px;
}

.article::after {
	position: absolute;
	content: '';
	bottom: -14px;
	left: 0;
	width: 100%;
	height: 1px;
	background: #e7e7e7;
}

.textAreaBox {
	width: 100%;
	margin-bottom: 32px;
}

.textAreaBox p {
	display: none;
}

.middle-title {
	margin-bottom: 24px;
}

.textAreaBox textarea {
	width: 100%;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	font-size: 20px;
	color: #000000;
	padding: 10px;
	min-height: 80px;
	resize: none;
	overflow: auto;
	/*font-family: 'Noto Sans KR';*/
	font-weight: 500;
}

.article-title {
	padding-bottom: 24px;
}

.select-content {
	width: 100%;
}

.select-content > div {
	margin: 18px 0;
}

.checkBoxItem {
	display: flex;
	align-items: center;
}

label {
	font-size: 1.8rem !important;
	margin-bottom: 0px !important;
	padding-bottom: 0px !important;
}

.checkBoxItem label {
	font-size: 20px;
	margin-left: 12px;
}

.checkBoxItem input {
	width: 22px;
	height: 22px;
}

.checkBoxItem ~ div > select {
	width: 100%;
	height: 45px;
	border: 1px solid #272727;
	font-size: 20px;
	color: #7d7d7d;
	font-weight: 500;
	margin: 13px 0 6px;
}

.btn-outlined {
	width: 120px;
	height: 38px;
	background-color: #fff !important;
	font-size: 1.6rem !important;
	outline: none !important;
	border: 1px solid #969696 !important;
	border-radius: 6px !important;
	color: #444444 !important;
	cursor: pointer;
}

.help-input {
	width: 100%;
	height: 45px;
	background: #fdfcfc;
	border: 1px solid #e7e7e7;
	padding: 11px;
	margin: 13px 0px 25px;
	font-size: 20px;
	font-weight: 500;
	color: #000000;
}

.help-input::placeholder {
	color: #7d7d7d;
}
</style>
